<template>
  <div>
    <div class="relative bg-gray-100" style="padding-bottom: 66.666667%" @click="$emit('view')">
      <div class="absolute w-full h-full inline-flex items-center justify-center cursor-pointer">
        <div class="flex flex-col items-center space-y-4">
          <svg viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12 text-gray-600">
            <path
              fill="currentColor"
              class="text-yellow-600"
              d="M21 15l-6 5.996L4.002 21A.998.998 0 0 1 3 20.007V3.993C3
              3.445 3.445 3 3.993 3h16.014c.548 0 .993.456.993 1.002V15zM19
              5H5v14h8v-5a1 1 0 0 1 .883-.993L14 13l5-.001V5zm-.829
              9.999L15 15v3.169l3.171-3.17z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div v-if="!withoutActions" class="flex">
      <portal :to="`notes-${note.id}-actions`">
        <BaseButton ghost squared @click="$emit('view')" class="flex-1 text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="inline-block w-4 h-4 focus:outline-none"
            v-tip="{ content: 'view note' }"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427
            9-10.819 9-5.392 0-9.878-3.88-10.819-9C2.121 6.88
            6.608 3 12 3zm0 16a9.005 9.005 0 0 0 8.777-7 9.005
            9.005 0 0 0-17.554 0A9.005 9.005 0 0 0 12 19zm0-2.5a4.5
            4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-2a2.5 2.5 0 1 0 0-5
            2.5 2.5 0 0 0 0 5z"
            />
          </svg>
        </BaseButton>
      </portal>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssetableNote',
  props: {
    withoutActions: Boolean,
    note: {
      type: Object,
      required: true,
    },
  },
};
</script>
